import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import auth from './modules/auth'
import pagination from './modules/pagination'
import tenancy from './modules/tenancy'
import localization from './modules/localization'
import locale from './modules/locale'
import sm from './modules/sm'
import sales from './modules/sales'
import customers from './modules/customers'
import catalog from './modules/catalog'
import campaigns from './modules/campaigns'
import authentication from './modules/authentication'
import cms from './modules/cms'
import timezone from './modules/timezone'

import * as getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  getters,
  modules: {
    app,
    auth,
    pagination,
    tenancy,
    localization,
    locale,
    sm,
    sales,
    customers,
    catalog,
    campaigns,
    authentication,
    cms,
    timezone
  },
  state: {},
  mutations: {}
})

export default store
